export const productAboutSx = {
	container: {
		p: { xs: '10px', md: '20px' },
		m: 0,
		display: 'flex',
		flexDirection: 'column',
		gap: '10px',
	},
	text: {
		color: 'grey.500',
	},
	details: {
		color: 'grey.300',
	},
	link: {
		color: 'secondary.main',
		cursor: 'pointer',
	},
	divider: {
		mb: '10px',
	},
	detailsContainer: {
		display: 'flex',
		gap: '10px',
	},
	detailContainer: {
		display: 'flex',
		gap: '5px',
	},
};
